export default __webpack_public_path__ + "static/media/bag.5517258f.svg";